import React, { useState } from 'react'

const PlayFromBeginIcon = ({ color = '#fff', hoverColor = '#bbfa33', imgClass = '' }) => {
  const [isHovered, setIsHovered] = useState(false)
  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  const handleMouseLeave = () => {
    setIsHovered(false)
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27 27"
      className={imgClass}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <path style={{ fill: 'none' }} d="M0 0h27v27H0z" />
      <path
        d="M5.26 13.281 16 20.116a.561.561 0 0 0 .863-.473V5.972A.561.561 0 0 0 16 5.5L5.26 12.334a.561.561 0 0 0 0 .947z"
        transform="translate(4.464 .663)"
        style={{
          fillRule: 'evenodd',
          stroke: isHovered ? hoverColor : color,
          strokeWidth: '2.5px',
          fill: 'none',
        }}
      />
      <path
        data-name="Path"
        transform="translate(6 6)"
        style={{ stroke: isHovered ? hoverColor : color, strokeWidth: '2.5px', fill: 'none' }}
        d="M0 0v15"
      />
    </svg>
  )
}

export default PlayFromBeginIcon
